module.exports = __webpack_public_path__ + "static/media/woo11.3005cb38.png";